import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Register Click Example")]),_c(VBtn,{attrs:{"disabled":!_vm.isSubmitting},on:{"click":function($event){return _vm.createDataForSubmit()}}},[_vm._v(" Register Click ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }